import React from 'react';
import { useNavigate, useSearchParams } from "react-router-dom";
import { GetParamCaseInsensitive } from "helpers/objects";
import { useEffectOnLoad } from "helpers/hooks/useEffectOnLoad";
import LoadingLinearProgress from "components/Common/LoadingLinearProgress";
import SaberisAPI from "./SaberisAPI";

interface IProps {
}

const SaberisLandingPage: React.FC<IProps> = (props: IProps) => {
    // This page only reads some expected query parameters. It sets the Saberis token to the provided token, then redirects to the provided relative URL
    const [query] = useSearchParams();
    const navigate = useNavigate();

    const redirectPath = GetParamCaseInsensitive(query, "redirectpath");
    const accessToken = GetParamCaseInsensitive(query, "access_token");
    const refreshToken = GetParamCaseInsensitive(query, "refresh_token");

    useEffectOnLoad(() => {
        SaberisAPI.SetTokens(accessToken ?? "", refreshToken ?? "").then(() => {
            navigate(redirectPath ?? "/dashboard");
        })
    })

    return <LoadingLinearProgress />;
}


export default SaberisLandingPage;
